import Axios from 'axios'

const ExcursionsModule = {
  namespaced: true,
  state: {
    property_1: [],
    property_2: [],
    property_3: []
  },
  mutations: {
    setExcursionItems (state, { propertyId, excursions }) {
      state[`property_${propertyId}`] = excursions
    }
  },
  actions: {
    async fetchPropertyExcursions ({ commit }, { propertyId }) {
      try {
        const res = await Axios.get(`/property/${propertyId}/excursions`)
        if (res) {
          commit('setExcursionItems', { propertyId, excursions: res.data })
        }
      } catch (e) {
        commit('setExcursionItems', { propertyId, excursions: [] })
        throw e
      }
    }
  },
  getters: {
    propertyExcursions: (state) => {
      return state
    }
  }
}

export default ExcursionsModule
